import angular from 'angular'

import globalResources from './resources/resources.module'
import globalDirectives from './directives/elements.module'
import globalServices from './services/service.module'

const name = 'globalModule'

angular.module(name, [globalDirectives, globalServices, globalResources,])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/global.module.js